import { render, staticRenderFns } from "./RecentlyViewed.vue?vue&type=template&id=85dd03de&scoped=true&"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js&"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyViewed.vue?vue&type=style&index=0&id=85dd03de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd03de",
  null
  
)

export default component.exports